import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 22 22">
      <path
        stroke="#1199FA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10.676 4.651l2.191-2.282c1.826-1.825 4.838-1.825 6.664 0 1.826 1.826 1.826 4.838 0 6.755l-4.2 4.2c-1.825 1.825-4.837 1.825-6.663 0-.274-.274-.822-1.005-1.095-1.37"
      />
      <path
        stroke="#1199FA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10.676 4.651l2.191-2.282c1.826-1.825 4.838-1.825 6.664 0 1.826 1.826 1.826 4.838 0 6.755l-4.2 4.2c-1.825 1.825-4.837 1.825-6.663 0-.274-.274-.822-1.005-1.095-1.37"
      />
      <path
        stroke="#1199FA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M11.224 17.431l-2.191 2.282c-1.826 1.826-4.838 1.826-6.664 0-1.825-1.825-1.825-4.838 0-6.755l4.2-4.199c1.825-1.826 4.837-1.826 6.663 0 .274.274.822 1.004 1.096 1.37"
      />
    </svg>
  )
}

export default Icon
